import React, { Component } from "react";
import styled from "styled-components";
import GoogleMapReact from "google-map-react";
import { below } from "../style/functions";

const API_KEY = "AIzaSyA8KUiV_oKDsIlieOMVZc6uT9GA5pk1Ya4";

const Marker = () => (
  <div className="marker">
    <img src="/images/marker.svg" />
  </div>
);

class GoogleMap extends Component {
  static defaultProps = {
    lat: -37.781251,
    lng: 145.029669,
    zoom: 14
  };

  createMapOptions = maps => {
    return {
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false,
      styles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f7f7f7"
            }
          ]
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161"
            }
          ]
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5"
            }
          ]
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              visibility: "simplified"
            }
          ]
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#dadada"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#feffff"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161"
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e"
            }
          ]
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5"
            }
          ]
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#c9c9c9"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e"
            }
          ]
        }
      ]
    };
  };

  render() {
    const { lat, lng } = this.props;
    return (
      <MapWrapper>
        <GoogleMapReact
          bootstrapURLKeys={{ key: API_KEY }}
          defaultCenter={{ lat, lng }}
          defaultZoom={this.props.zoom}
          options={this.createMapOptions}
        >
          <Marker lat={lat} lng={lng} />
        </GoogleMapReact>
      </MapWrapper>
    );
  }
}

const MapWrapper = styled.div`
  height: 70vh;
  min-height: 600px;
  width: "100%";
  .marker {
    width: 100px;
    position: absolute;
    top: -130px;
    left: -50px;
  }
  ${below.desktop`
    min-height: 300px;
    .marker{
    width: 60px;
    position: absolute;
    top: -80px;
    left: -30px;
  }
  `};
`;

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/google_map.js